/**
 * Created by tomers on 9/20/2015.
 */

define(function (require) {
    "use strict";

    var LE = require("app");
    var CONST = require("const");
    var StringFormats = require("utils/StringFormats");
    var LEResourceResolver = require("leResourceResolver");

    var Page = require("ui.components/page/Page");
    var FileUploadInput = require('ui/file-upload-input/FileUploadInput');
    var AppKeyEditView = require("manager-views/data-sources/integrations/app-keys/AppKeyEditView");
    var AppKeyModel = require("manager-models/data-sources/integrations/app-keys/AppKeyModel");
    var AppKeyFileModel = require("manager-models/data-sources/integrations/app-keys/AppKeyFileModel");

    var RESPONSE_DATA = {
        ERROR_STATE: "error"
    };

    var ERROR_MSG_MAP = {};
    ERROR_MSG_MAP[AppKeyModel.KEYS.CERTIFICATE] = "LEManager.appEdit.app.errors.iosFiles.generalError";
    ERROR_MSG_MAP[AppKeyModel.KEYS.KEY] = "LEManager.appEdit.app.errors.iosFiles.generalError";

    var AppKeyEditController = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        AppKeyEditController = Marionette.Controller.extend({
            pageView: null,
            insideView: null,
            appModel: null,
            isModelChanged: false,
            needToRenderView: true,


            initialize: function(options) {
                this._initialize(options);
            },
            getMainView: function () {
                return this._getMainView();
            },
            show: function (appId) {
                this._show(appId);
            },


            _initialize: function(options) {
                LEManager.logger.info("initializing", "AppKeyEditController:initialize");

                this.channel = LEManager.media.channel("appKeyEdit");
                this._bindEvents();
            },

            _bindEvents: function() {
                LEManager.logger.debug("bind events to channel", "AppKeyEditController:_bindEvents");

                this.listenTo(this.channel.vent, "app:change:platform", this._onAppPlatformChange);
                this.listenTo(this.channel.vent, "app:change:name", this._onAppNameChange);
                this.listenTo(this.channel.vent, "app:change:androidNotificationKey", this._onAppAndroidNotificationKeyChange);
                this.listenTo(this.channel.vent, "app:change:proxyEndpointURL", this._onAppProxyEndpointURLChange);
                this.listenTo(this.channel.vent, "app:change:proxyAuthorizationHeader", this._onAppProxyAuthorizationHeaderChange);
                this.listenTo(this.channel.vent, "app:change:proxyCertificateFile", this._onProxyCertificateFileChange);
                this.listenTo(this.channel.vent, "app:remove:proxyCertificateFile", this._onProxyCertificateFileRemove);
                this.listenTo(this.channel.vent, "app:change:proxyKeyFile", this._onProxyKeyFileChange);
                this.listenTo(this.channel.vent, "app:remove:proxyKeyFile", this._onProxyKeyFileRemove);
                this.listenTo(this.channel.vent, "app:change:production", this._onProductionChange);
                this.listenTo(this.channel.vent, "app:change:iosCertificateFile", this._onIOSCertificateFileChange);
                this.listenTo(this.channel.vent, "app:remove:iosCertificateFile", this._onIOSCertificateFileRemove);
                this.listenTo(this.channel.vent, "app:change:iosKeyFile", this._onIOSKeyFileChange);
                this.listenTo(this.channel.vent, "app:remove:iosKeyFile", this._onIOSKeyFileRemove);
                this.listenTo(this.channel.vent, "app:createApp", this._onCreateAppClick);
                this.listenTo(this.channel.vent, "app:close", this._onAppClose);
            },

            _getMainView: function() {
                LEManager.logger.debug("creating and returning the page view", "AppKeyEditController:_getMainView");

                this._initPageView();
                return this.pageView;
            },

            _initPageView: function() {
                if (this.needToRenderView) {
                    if (this.pageView) {
                        this.pageView.close();
                    }
                    this.pageView = new Page({
                        moduleName: LEManager.moduleName,
                        context: LE.context,
                        permutation: Page.PERMUTATION.Dialog,
                        hasActionStrip: false,
                        header:{
                            knowledgePack: {text: LE.translator.translate("LEFramework.global.captions.learnMore"), eventId: "liveengage-mobile-sdk"},
                            description: LE.translator.translate("LEManager.appEdit.header.description")
                        }
                    });
                }
            },

            _show: function(appKey) {
                LEManager.logger.info("show app edit", "AppKeyEditController:_show", appKey);

                this.isModelChanged = false;

                if (!this.needToRenderView) {
                    this.needToRenderView = true;
                    return;
                }

                this._showLoader();
                if (appKey === CONST.ROUTING.NEW_ITEM_ID) {
                    this._createNewApp();
                }
                else {
                    this._fetchApp(appKey);
                }
            },

            _createNewApp: function() {
                this.appModel = new AppKeyModel();
                this._showEditView();
            },

            _fetchApp: function(appKey) {
                this.appModel = new AppKeyModel({applicationKey:appKey});
                this.appModel.fetch({
                    success: _.bind(this._showEditView, this),
                    error:  _.bind(this._onFetchAppError, this)
                });
            },

            _onFetchAppError: function() {
                this._closeLoader();
                LEManager.notifier.showError({content:LE.translator.translate("LEUserManagement.userEdit.errorOnFetching.text"), timeToShow: 6000});
                LEManager.router.navigateBack();
            },

            _showEditView: function() {
                LEManager.logger.debug("initialize and show the app edit view in the page", "AppKeyEditController:_showEditView");

                var title = (this.appModel.isNew()) ? LE.translator.translate("LEManager.appEdit.header.title.new") : LE.translator.translate("LEManager.appEdit.header.title.edit");
                this.pageView.setTitle(title);

                this._initSubViews();
                this.insideView = new AppKeyEditView({
                    model: this.appModel,
                    iosCertificateFileView: this.iosCertificateFileView,
                    iosKeyFileView: this.iosKeyFileView,
                    proxyCertificateFileView: this.proxyCertificateFileView,
                    proxyKeyFileView: this.proxyKeyFileView
                });
                this.pageView.setInsideView(this.insideView);

                this._closeLoader();
            },

            _initSubViews: function() {
                this.iosCertificateFileView = null;
                this.iosKeyFileView = null;
                this.proxyCertificateFileView = null;
                this.proxyKeyFileView = null;

                if (!this.appModel.isNew() && this.appModel.isIOS()) {
                    this.iosCertificateFileView = new FileUploadInput({
                        uploadUrl: this._getFileUploadAPIUrl(AppKeyModel.IMPORT_FILE_TYPE.CERTIFICATE),
                        sessionToken: LE.sessionManager.getGlob(),
                        frameContainerClassName: "certificate-file-frame-container",
                        buttonText: "...",
                        buttonOnRight: true,
                        uploadExtensions: ["pem"],
                        errorPosition: FileUploadInput.ERROR_POSITION.BOTTOM
                    });

                    this.iosKeyFileView = new FileUploadInput({
                        uploadUrl: this._getFileUploadAPIUrl(AppKeyModel.IMPORT_FILE_TYPE.KEY),
                        sessionToken: LE.sessionManager.getGlob(),
                        frameContainerClassName: "key-file-frame-container",
                        buttonOnRight: true,
                        buttonText: "...",
                        uploadExtensions: ["pem"],
                        errorPosition: FileUploadInput.ERROR_POSITION.BOTTOM
                    });
                }

                if (!this.appModel.isNew() && this.appModel.isProxy()) {
                    this.proxyCertificateFileView = new FileUploadInput({
                        uploadUrl: this._getFileUploadAPIUrl(AppKeyModel.IMPORT_FILE_TYPE.CERTIFICATE),
                        sessionToken: LE.sessionManager.getGlob(),
                        frameContainerClassName: "certificate-file-frame-container",
                        buttonText: "...",
                        buttonOnRight: true,
                        uploadExtensions: ["pem"],
                        errorPosition: FileUploadInput.ERROR_POSITION.BOTTOM
                    });

                    this.proxyKeyFileView = new FileUploadInput({
                        uploadUrl: this._getFileUploadAPIUrl(AppKeyModel.IMPORT_FILE_TYPE.KEY),
                        sessionToken: LE.sessionManager.getGlob(),
                        frameContainerClassName: "key-file-frame-container",
                        buttonOnRight: true,
                        buttonText: "...",
                        uploadExtensions: ["pem"],
                        errorPosition: FileUploadInput.ERROR_POSITION.BOTTOM
                    });
                }
            },

            _getFileUploadAPIUrl: function(fileType){
                var isCertificate = (fileType === AppKeyModel.IMPORT_FILE_TYPE.CERTIFICATE);
                var fileId = (isCertificate) ? this.appModel.getCertificateId() : this.appModel.getKeyId();
                var fileRevision = (isCertificate) ? this.appModel.getCertificateRevision() : this.appModel.getKeyRevision();

                var params = {
                    applicationId: this.appModel.id,
                    fileType: fileType,
                    fileId: (fileId) ? fileId : "",
                    revisionParam: (fileId) ? "&revision="+fileRevision : ""
                };
                var resource = LEResourceResolver.extendResourceWithOptions.call(this, LEResourceResolver.apiResources.Applications.FileUpload, params);
                var url = LEResourceResolver.getUrl(resource);

                return url;
            },

            _getFileUploadResponseValidity: function(data, fileType){
                var result = {
                    isValid: true,
                    errors: {}
                };
                if (_.has(data, "state") && data.state === RESPONSE_DATA.ERROR_STATE){
                    result.isValid = false;
                    result.errors[fileType] = ERROR_MSG_MAP[fileType];
                }
                return result;
            },

            _onAppPlatformChange: function(platform) {
                this.appModel.setOperatingSystem(platform);
            },

            _onAppNameChange: function(name) {
                var needSave = !this.appModel.isNew() && name !== this.appModel.getName(); // if this is an existing app and the name has changed

                this.appModel.setName(name);
                if (this.appModel.isAndroid()){
                    //there is a bug in BE where in Android, if we change only the name it will fail if AndroidKeyForUpdate attribute is not sent
                    var notificationKey = this.appModel.getAndroidNotificationKey();
                    this.appModel.setAndroidKeyForUpdate(notificationKey);
                }
                if (needSave) {
                    this._saveApp();
                }
            },

            _onAppAndroidNotificationKeyChange: function(notificationKey) {
                var needSave = !this.appModel.isNew() && notificationKey !== this.appModel.getAndroidNotificationKey(); // if this is an existing app and the key has changed

                this.appModel.setAndroidNotificationKey(notificationKey);
                if (needSave) {
                    this._saveApp();
                }
            },

            _onAppProxyEndpointURLChange: function(endpointURL) {
                // if this is an existing app and the url has changed
                var needSave = !this.appModel.isNew() && endpointURL !== this.appModel.getEndpointURL();

                this.appModel.setEndpointURL(endpointURL);
                if (needSave) {
                    this._saveApp();
                }
            },

            _onAppProxyAuthorizationHeaderChange: function(authorizationHeader) {
                var needSave = authorizationHeader !== this.appModel.getProxyAuthorizationHeader();

                this.appModel.setProxyAuthorizationHeader(authorizationHeader);
                if (needSave) {
                    this._saveApp();
                }
            },

            _onProxyCertificateFileRemove: function() {
                this._beforeSave();
                var appFileModel = new AppKeyFileModel(this.appModel.getCertificate(), {appId:this.appModel.id});
                appFileModel.destroy({
                    success: _.bind(this._onProxyCertificateChangeSuccess, this, {}),
                    error: _.bind(this._onProxyCertificateChangeError, this)
                });
            },

            _onProxyCertificateFileChange: function(data) {
                this._beforeSave();
                if (this._validateFileExtension(data, AppKeyModel.IMPORT_FILE_TYPE.CERTIFICATE)) {
                    this.listenTo(this.proxyCertificateFileView, "upload:uploadComplete", this._onProxyCertificateChangeSuccess);
                    this.listenTo(this.proxyCertificateFileView, "upload:error", this._onProxyCertificateChangeError);
                    this.proxyCertificateFileView.startUpload();
                }
            },

            _onProxyCertificateChangeSuccess: function(data) {
                data = data || {};

                this.stopListening(this.proxyCertificateFileView);

                var validity = this._getFileUploadResponseValidity(data, AppKeyModel.KEYS.CERTIFICATE);
                if (validity.isValid){
                    this.appModel.setCertificate(data.message);
                    var uploadUrl = this._getFileUploadAPIUrl(AppKeyModel.IMPORT_FILE_TYPE.CERTIFICATE);
                    //console.log("new upload url:", uploadUrl);
                    this.proxyCertificateFileView.updateUploadUrl(uploadUrl);

                    this._onSaveAppSuccess();
                }
                else {
                    this._onSaveAppInvalid(this.appModel, validity.errors);
                }

            },

            _onProxyCertificateChangeError: function() {
                this.stopListening(this.proxyCertificateFileView);

                var errors = {};
                errors[AppKeyModel.KEYS.CERTIFICATE] = ERROR_MSG_MAP[AppKeyModel.KEYS.CERTIFICATE];

                this._onSaveAppInvalid(this.appModel, errors);
            },

            _onProxyKeyFileRemove: function() {
                this._beforeSave();
                var appFileModel = new AppKeyFileModel(this.appModel.getKey(), {appId:this.appModel.id});
                appFileModel.destroy({
                    success: _.bind(this._onProxyKeyChangeSuccess, this, {}),
                    error: _.bind(this._onProxyKeyChangeError, this)
                });
            },

            _onProxyKeyFileChange: function(data) {
                this._beforeSave();
                if (this._validateFileExtension(data, AppKeyModel.IMPORT_FILE_TYPE.KEY)) {
                    this.listenTo(this.proxyKeyFileView, "upload:uploadComplete", this._onProxyKeyChangeSuccess);
                    this.listenTo(this.proxyKeyFileView, "upload:error", this._onProxyKeyChangeError);
                    this.proxyKeyFileView.startUpload();
                }
            },

            _onProxyKeyChangeSuccess: function(data) {
                data = data || {};

                this.stopListening(this.proxyKeyFileView);

                var validity = this._getFileUploadResponseValidity(data, AppKeyModel.KEYS.KEY);
                if (validity.isValid){
                    this.appModel.setKey(data.message);
                    var uploadUrl = this._getFileUploadAPIUrl(AppKeyModel.IMPORT_FILE_TYPE.KEY);
                    this.proxyKeyFileView.updateUploadUrl(uploadUrl);

                    this._onSaveAppSuccess();
                }
                else {
                    this._onSaveAppInvalid(this.appModel, validity.errors);
                }
            },

            _onProxyKeyChangeError: function() {
                this.stopListening(this.proxyKeyFileView);

                var errors = {};
                errors[AppKeyModel.KEYS.KEY] = ERROR_MSG_MAP[AppKeyModel.KEYS.KEY];

                this._onSaveAppInvalid(this.appModel, errors);
            },

            _onProductionChange: function(enabled) {
                this.appModel.setDevApp(enabled);
                this._saveApp();
            },

            _onIOSCertificateFileRemove: function() {
                this._beforeSave();
                var appFileModel = new AppKeyFileModel(this.appModel.getCertificate(), {appId:this.appModel.id});
                appFileModel.destroy({
                    success: _.bind(this._onIOSCertificateChangeSuccess, this, {}),
                    error: _.bind(this._onIOSCertificateChangeError, this)
                });
            },

            _onIOSCertificateFileChange: function(data) {
                this._beforeSave();
                if (this._validateFileExtension(data, AppKeyModel.IMPORT_FILE_TYPE.CERTIFICATE)) {
                    this.listenTo(this.iosCertificateFileView, "upload:uploadComplete", this._onIOSCertificateChangeSuccess);
                    this.listenTo(this.iosCertificateFileView, "upload:error", this._onIOSCertificateChangeError);
                    this.iosCertificateFileView.startUpload();
                }
            },

            _onIOSCertificateChangeSuccess: function(data) {
                data = data || {};

                this.stopListening(this.iosCertificateFileView);

                var validity = this._getFileUploadResponseValidity(data, AppKeyModel.KEYS.CERTIFICATE);
                if (validity.isValid){
                    this.appModel.setCertificate(data.message);
                    var uploadUrl = this._getFileUploadAPIUrl(AppKeyModel.IMPORT_FILE_TYPE.CERTIFICATE);
                    //console.log("new upload url:", uploadUrl);
                    this.iosCertificateFileView.updateUploadUrl(uploadUrl);

                    this._onSaveAppSuccess();
                }
                else {
                    this._onSaveAppInvalid(this.appModel, validity.errors);
                }

            },

            _onIOSCertificateChangeError: function() {
                this.stopListening(this.iosCertificateFileView);

                var errors = {};
                errors[AppKeyModel.KEYS.CERTIFICATE] = ERROR_MSG_MAP[AppKeyModel.KEYS.CERTIFICATE];

                this._onSaveAppInvalid(this.appModel, errors);
            },

            _onIOSKeyFileRemove: function() {
                this._beforeSave();
                var appFileModel = new AppKeyFileModel(this.appModel.getKey(), {appId:this.appModel.id});
                appFileModel.destroy({
                    success: _.bind(this._onIOSKeyChangeSuccess, this, {}),
                    error: _.bind(this._onIOSKeyChangeError, this)
                });
            },

            _onIOSKeyFileChange: function(data) {
                this._beforeSave();
                if (this._validateFileExtension(data, AppKeyModel.IMPORT_FILE_TYPE.KEY)) {
                    this.listenTo(this.iosKeyFileView, "upload:uploadComplete", this._onIOSKeyChangeSuccess);
                    this.listenTo(this.iosKeyFileView, "upload:error", this._onIOSKeyChangeError);
                    this.iosKeyFileView.startUpload();
                }
            },

            _onIOSKeyChangeSuccess: function(data) {
                data = data || {};

                this.stopListening(this.iosKeyFileView);

                var validity = this._getFileUploadResponseValidity(data, AppKeyModel.KEYS.KEY);
                if (validity.isValid){
                    this.appModel.setKey(data.message);
                    var uploadUrl = this._getFileUploadAPIUrl(AppKeyModel.IMPORT_FILE_TYPE.KEY);
                    //console.log("new upload url:", uploadUrl);
                    this.iosKeyFileView.updateUploadUrl(uploadUrl);

                    this._onSaveAppSuccess();
                }
                else {
                    this._onSaveAppInvalid(this.appModel, validity.errors);
                }
            },

            _onIOSKeyChangeError: function() {
                this.stopListening(this.iosKeyFileView);

                var errors = {};
                errors[AppKeyModel.KEYS.KEY] = ERROR_MSG_MAP[AppKeyModel.KEYS.KEY];

                this._onSaveAppInvalid(this.appModel, errors);
            },

            _onCreateAppClick: function() {
                this._saveApp({
                    success: _.bind(this._onCreateAppSuccess, this)
                });
            },

            _onCreateAppSuccess: function(model, resp, options) {
                this.needToRenderView = false;
                LEManager.router.navigateNonBackable("data/integrations/appKeys/" + model.id, {replace:true});
                this._afterSave();
                LEManager.notifier.showSuccess({content: LE.translator.translate("LEManager.appEdit.app.created.success.text"), timeToShow: 6000});

                this._initSubViews();
                this.channel.trigger("app:createApp:success", {
                    iosCertificateFileView: this.iosCertificateFileView,
                    iosKeyFileView: this.iosKeyFileView,
                    proxyCertificateFileView: this.proxyCertificateFileView,
                    proxyKeyFileView: this.proxyKeyFileView
                });
            },

            _saveApp: function(options) {
                options = options || {};

                this._beforeSave();
                var success = options.success || _.bind(this._onSaveAppSuccess, this);
                var error = options.error || _.bind(this._onSaveAppError, this);
                this.appModel.save(null, {
                    ignoreError: true,
                    success: success,
                    error: error
                });
            },

            _onSaveAppSuccess: function(model, resp, options) {
                this._afterSave();
                LEManager.notifier.showSuccess({content: LE.translator.translate("LEManager.appEdit.app.saved.success.text"), timeToShow: 6000});
                this.channel.trigger("app:save:success", model);
            },

            _onSaveAppError: function(model, resp, options) {
                this._afterSave();

                LEManager.notifier.showError({content: StringFormats.getGeneralErrorMsg(), timeToShow: 6000});
                this.channel.trigger("app:save:error");
            },

            _onSaveAppInvalid: function(model, errorObject) {
                this._afterSave();

                var translatedErrorObj = {};
                _.each(errorObject, function (value, key, obj) {
                    translatedErrorObj[key] = LE.translator.translate(value);
                });

                LEManager.notifier.showError({content: StringFormats.getGeneralErrorMsg(errorObject), timeToShow: 6000});
                this.channel.trigger("app:save:error", translatedErrorObj);
            },

            _beforeSave: function() {
                this._showLoader();
                this.listenTo(this.appModel, "invalid", this._onSaveAppInvalid);
                LEManager.vent.trigger("app:enableNavigation", false);
            },

            _afterSave: function() {
                this._closeLoader();
                this.stopListening(this.appModel, "invalid");
                setTimeout(_.bind(function() {
                    LEManager.vent.trigger("app:enableNavigation", true);
                }, this), 100);
            },

            _validateFileExtension: function(data, fileType) {
                var fileName = data.file.name;
                var fileExtension = fileName.substr(fileName.lastIndexOf(".") + 1);

                var errors = {};
                if (fileExtension.toLowerCase() !== AppKeyFileModel.VALID_FILE_EXTENSION.toLowerCase()) {
                    var attributeName = AppKeyModel.KEYS[_.invert(AppKeyModel.IMPORT_FILE_TYPE)[fileType]];
                    errors[attributeName] = "LEManager.appEdit.app.errors.iosFiles.extensionNotSupported";
                }

                if (_.isEmpty(errors)) {
                    return true;
                }
                else {
                    this._onSaveAppInvalid(this.appModel, errors);
                    return false;
                }
            },

            _showLoader: function() {
                if (this.pageView) {
                    this.pageView.showLoader();
                }
            },

            _closeLoader: function() {
                if (this.pageView) {
                    this.pageView.closeLoader();
                }
            },

            _onAppClose: function() {
                LEManager.router.navigateBack();
            }

        });
    }

    LE.module("LEManager", moduleDefinition);

    return AppKeyEditController;
});
